// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    padding: 0;
    margin: 0;
}

.MAMheading{
    margin: 0 5vw 0 5vw;
    display: flex;
    align-items: center;
}

.MAMactivity-image{
    width: 70px;
    margin-right: 20px;
}

.question-text {
    font-size: 35px; /* Change to your desired font size */
    /*font-weight: bold; /* Optional: to make the text bold */
    line-height: 1.5; /* Optional: for better spacing */
}

.MAMactivity-image img{
    width: 100%;
}

.MAMactivity-text{
    color: rgb(227, 135, 35);
    font-size: 20px;
}

.MAMcontainer{
    margin: 0 5vw 0 5vw;
}

.MAMhead{
    display: flex;
}

.MAMquestions{
    flex: 5 1;
    background-color: rgb(227, 135, 35);
    padding: 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: aliceblue;
    border-radius: 10px 0 0 10px;
    
}


#total-questions{
    margin-left: 2px;
}

.MAMprogress-bar{
    height: 5px;
    width: 130px;
    background-color: rgb(154, 168, 168);
    border-radius: 5px;
    margin-top: 5px;
}

#progress{
    height: 5px;
    width: 0;
    background-color: aqua;
    border-radius: 5px;
}

.MAMscore{
    flex: 1 1;
    padding-top: 3px;
    display: flex;
    flex-direction: column;
    background-color: rgb(64, 163, 64);
    color: white;
    text-align: center;
    border-radius: 0px 10px 10px 0;
    justify-content: space-between;
}

.MAMnumbered-score{
    background-color: rgb(158, 196, 158);
    border-radius: 15px;
    padding: 10px;

}

.MAMbody{
    background-color: rgb(250, 240, 214);
    display: flex;
    border-radius: 15px 0 0 15px;
}

.MAMremaining-body{
    background-color: rgb(250, 240, 214);
    flex: 5 1;
    padding: 20px;
    display: grid;
    grid-template-columns: 4fr 3fr 1fr;
    column-gap: 10px;
    row-gap: 20px;

    border-radius: 15px 0 0 15px;

    
}

.MAMquestion{
    border-width: 2px;
    border-color: rgb(227, 135, 35);
    border-style: solid;
    text-align: center;
    color: rgb(227, 135, 35);
    font-size: 30px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 0.MAM5fr;
}


.MAMmental-question-section{
    display: flex;
    justify-content: center;
}

.MAMmental-question-section h4{
    margin-top: 15px;
}

.MAMmental-question-section img{
    width: 30px;
    margin-right: 5px;
}

.MAMplay-question{
    background-color: rgb(250, 240, 214);
    border: none;
    cursor: pointer;
}

.MAMplay-question img{
    flex: 1 1;
    background-color: rgb(250, 240, 214);
    border: none;
    cursor: pointer;
}

.MAMplay-question img:active{
    width: 90px;
}

.MAMpicture img{
    width: 300px;
}


.MAMtime{
    display: flex;
    border: 2px solid red;
    height: 40px;
    border-radius: 20px;
    margin-bottom: 10px;
}

.MAMtime-text{
    background-color: red;
    color: white;
    border-radius: 18px;
    display: flex;
    align-items: center;
    padding: 15px;
}

.MAMtimer{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 15px;
}

.MAMmarks{
    display: flex;
    border: 2px solid rgb(170, 96, 0);;
    height: 40px;
    border-radius: 20px;
    margin-bottom: 10px;
}

.MAMmarks-text{
    background-color: rgb(170, 96, 0);
    color: white;
    border-radius: 18px;
    display: flex;
    align-items: center;
    padding: 15px;
}

.MAMmarker{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 15px;
}

.MAMinstructions-dropdown{
    background-color: rgb(250, 240, 214);
    color: rgb(227, 135, 35);
    padding: 15px;
    font-size: 15px;
}

.MAManswer-submit input::placeholder{
    font-size: 15px;
}

.MAManswer{
    border: none;
    border-radius: 8px;
    padding: 15px 10px;
}

#submission{
    border: none;
    background-color: rgb(18, 18, 192);
    border-radius: 8px;
    color: white;
    padding: 15px 15px;
    cursor: pointer;
}

#marks-color{
    flex: 1 1;
    background-color: rgb(254, 236, 242);
    border: 1px solid rgb(227, 135, 35);
    border-radius: 0 10px 10px 0;
    overflow: scroll;
    max-height: 300px;
}

.MAMbox{
    display: flex;
    border: 2px solid rgb(227, 135, 35);
    margin: 0 10px 2px 10px;
}

.MAMbox1{
    flex: 1 1;
    border-width: 0 2px 0 0;
    border-color: rgb(227, 135, 35);
    border-style: solid;
    text-align: center;
}
.MAMbox2{
    flex: 1 1;
    background-color: red;
    
}

.MAMremarks{
    margin: 0 5vw 0 5vw;
    display: flex;
    justify-content: space-between;
}

.MAOanswer-submit {
    display: flex;
    /* flex-direction: column; Stack items vertically */
     gap: 30px; /* Adds spacing between elements */
  } 
`, "",{"version":3,"sources":["webpack://./src/MyComponents/Activities/MentalActivity/MentalActivity.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe,EAAE,qCAAqC;IACtD,yDAAyD;IACzD,gBAAgB,EAAE,iCAAiC;AACvD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,mCAAmC;IACnC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;;AAEhC;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,SAAO;IACP,aAAa;IACb,aAAa;IACb,kCAAkC;IAClC,gBAAgB;IAChB,aAAa;;IAEb,4BAA4B;;;AAGhC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,gCAAgC;AACpC;;;AAGA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,oCAAoC;IACpC,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,wBAAwB;IACxB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,oCAAoC;IACpC,mCAAmC;IACnC,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,SAAO;IACP,qBAAqB;;AAEzB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mDAAmD;KAClD,SAAS,EAAE,kCAAkC;EAChD","sourcesContent":["*{\n    padding: 0;\n    margin: 0;\n}\n\n.MAMheading{\n    margin: 0 5vw 0 5vw;\n    display: flex;\n    align-items: center;\n}\n\n.MAMactivity-image{\n    width: 70px;\n    margin-right: 20px;\n}\n\n.question-text {\n    font-size: 35px; /* Change to your desired font size */\n    /*font-weight: bold; /* Optional: to make the text bold */\n    line-height: 1.5; /* Optional: for better spacing */\n}\n\n.MAMactivity-image img{\n    width: 100%;\n}\n\n.MAMactivity-text{\n    color: rgb(227, 135, 35);\n    font-size: 20px;\n}\n\n.MAMcontainer{\n    margin: 0 5vw 0 5vw;\n}\n\n.MAMhead{\n    display: flex;\n}\n\n.MAMquestions{\n    flex: 5;\n    background-color: rgb(227, 135, 35);\n    padding: 25px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: aliceblue;\n    border-radius: 10px 0 0 10px;\n    \n}\n\n\n#total-questions{\n    margin-left: 2px;\n}\n\n.MAMprogress-bar{\n    height: 5px;\n    width: 130px;\n    background-color: rgb(154, 168, 168);\n    border-radius: 5px;\n    margin-top: 5px;\n}\n\n#progress{\n    height: 5px;\n    width: 0;\n    background-color: aqua;\n    border-radius: 5px;\n}\n\n.MAMscore{\n    flex: 1;\n    padding-top: 3px;\n    display: flex;\n    flex-direction: column;\n    background-color: rgb(64, 163, 64);\n    color: white;\n    text-align: center;\n    border-radius: 0px 10px 10px 0;\n    justify-content: space-between;\n}\n\n.MAMnumbered-score{\n    background-color: rgb(158, 196, 158);\n    border-radius: 15px;\n    padding: 10px;\n\n}\n\n.MAMbody{\n    background-color: rgb(250, 240, 214);\n    display: flex;\n    border-radius: 15px 0 0 15px;\n}\n\n.MAMremaining-body{\n    background-color: rgb(250, 240, 214);\n    flex: 5;\n    padding: 20px;\n    display: grid;\n    grid-template-columns: 4fr 3fr 1fr;\n    column-gap: 10px;\n    row-gap: 20px;\n\n    border-radius: 15px 0 0 15px;\n\n    \n}\n\n.MAMquestion{\n    border-width: 2px;\n    border-color: rgb(227, 135, 35);\n    border-style: solid;\n    text-align: center;\n    color: rgb(227, 135, 35);\n    font-size: 30px;\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr 0.MAM5fr;\n}\n\n\n.MAMmental-question-section{\n    display: flex;\n    justify-content: center;\n}\n\n.MAMmental-question-section h4{\n    margin-top: 15px;\n}\n\n.MAMmental-question-section img{\n    width: 30px;\n    margin-right: 5px;\n}\n\n.MAMplay-question{\n    background-color: rgb(250, 240, 214);\n    border: none;\n    cursor: pointer;\n}\n\n.MAMplay-question img{\n    flex: 1;\n    background-color: rgb(250, 240, 214);\n    border: none;\n    cursor: pointer;\n}\n\n.MAMplay-question img:active{\n    width: 90px;\n}\n\n.MAMpicture img{\n    width: 300px;\n}\n\n\n.MAMtime{\n    display: flex;\n    border: 2px solid red;\n    height: 40px;\n    border-radius: 20px;\n    margin-bottom: 10px;\n}\n\n.MAMtime-text{\n    background-color: red;\n    color: white;\n    border-radius: 18px;\n    display: flex;\n    align-items: center;\n    padding: 15px;\n}\n\n.MAMtimer{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 15px;\n}\n\n.MAMmarks{\n    display: flex;\n    border: 2px solid rgb(170, 96, 0);;\n    height: 40px;\n    border-radius: 20px;\n    margin-bottom: 10px;\n}\n\n.MAMmarks-text{\n    background-color: rgb(170, 96, 0);\n    color: white;\n    border-radius: 18px;\n    display: flex;\n    align-items: center;\n    padding: 15px;\n}\n\n.MAMmarker{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 15px;\n}\n\n.MAMinstructions-dropdown{\n    background-color: rgb(250, 240, 214);\n    color: rgb(227, 135, 35);\n    padding: 15px;\n    font-size: 15px;\n}\n\n.MAManswer-submit input::placeholder{\n    font-size: 15px;\n}\n\n.MAManswer{\n    border: none;\n    border-radius: 8px;\n    padding: 15px 10px;\n}\n\n#submission{\n    border: none;\n    background-color: rgb(18, 18, 192);\n    border-radius: 8px;\n    color: white;\n    padding: 15px 15px;\n    cursor: pointer;\n}\n\n#marks-color{\n    flex: 1;\n    background-color: rgb(254, 236, 242);\n    border: 1px solid rgb(227, 135, 35);\n    border-radius: 0 10px 10px 0;\n    overflow: scroll;\n    max-height: 300px;\n}\n\n.MAMbox{\n    display: flex;\n    border: 2px solid rgb(227, 135, 35);\n    margin: 0 10px 2px 10px;\n}\n\n.MAMbox1{\n    flex: 1;\n    border-width: 0 2px 0 0;\n    border-color: rgb(227, 135, 35);\n    border-style: solid;\n    text-align: center;\n}\n.MAMbox2{\n    flex: 1;\n    background-color: red;\n    \n}\n\n.MAMremarks{\n    margin: 0 5vw 0 5vw;\n    display: flex;\n    justify-content: space-between;\n}\n\n.MAOanswer-submit {\n    display: flex;\n    /* flex-direction: column; Stack items vertically */\n     gap: 30px; /* Adds spacing between elements */\n  } \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
